import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {
  ItemDetails, ItemWrapper, ItemOptions, ItemQuantity, Item, ItemPrice,
  Comment, OptionsList
} from './ConfirmationPage.style';
import Price from '../../components/Price/Price';
import {Em} from '../../components/Em/Em';
import {PROMOTION_TYPES} from '../../constants/constant';

class OrderItem extends PureComponent {
  render() {
    const { item } = this.props;
    const options = item.selectedOptions &&
      <OptionsList>
        {item.selectedOptions.map((option) =>
          <li key={option.group + option.selection}>{option.group} - {option.selection}</li>)
        }
      </OptionsList>;
    const comments = item.comments && item.comments.length > 0 && <Comment>{item.comments}</Comment>;
    const renderPrice = item.promotion && item.promotion.type === PROMOTION_TYPES.FREE_MEAL ? <FormattedMessage id="meal.free" /> : <Price amount={item.price} />;

    return (
      <ItemWrapper>
        <ItemQuantity>{item.quantity} x</ItemQuantity>
        <ItemDetails>
          <Item>
            <div>
              <Em data-rw="order-item--description">{item.size} {item.mealData && item.mealData.name}</Em>
              <ItemOptions>
                {options}
                {comments}
              </ItemOptions>
            </div>
            <ItemPrice>
              {renderPrice}
            </ItemPrice>
          </Item>
        </ItemDetails>
      </ItemWrapper>
    );
  }
}

OrderItem.propTypes = {
  item: PropTypes.object.isRequired
};

export default OrderItem;



// WEBPACK FOOTER //
// ./containers/ConfirmationPage/OrderItem.js